module.exports = __webpack_public_path__ + "img/birthday_cake.49e9e4fa.gif";